import { useQuery} from '@tanstack/react-query';

import { useWalletApi } from '../../hooks/useWalletApi';

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const useWallet = (queryParams: Params) => {
  
  const { getAllWallet } = useWalletApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['wallet', queryParams],
    queryFn: () => {
      return getAllWallet(queryParams);
    },
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch,
  };
};



